import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import { Link } from 'react-router-dom';


const BorrowingPolicies = () =>{
    const handleLinkClick = () => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
      };
return (
<div className="RightsandResponsibilities">
    <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/policies.jpg" alt="" />
    </section>
    <section className="research-box-area">
        <Container>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Patron / User Policies</BreadcrumbItem>
            </Breadcrumb>
            <div className='information-content'>
                <h2>Patron / User Policies</h2>
            </div>
            <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                            <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/BorrowingPolicies" 
                                    onClick={handleLinkClick} className='nav-link active'>
                                    Borrowing Policies
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerUsePolicy" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Computer Use Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/DiscussionRoomsPolicy" 
                                    onClick={handleLinkClick} className='nav-link' >
                                    Discussion Rooms Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibrarySpaces" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Library Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/FinesPenalty" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Fines & Penalty
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="policyBox">
                    <h5>Borrowing Policies</h5>
                    <p>HU community can issue general books as per following.</p>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Patron Type </th>
                                <th>Maximum Books </th>
                                <th>Duration</th>
                                <th>Renewal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Faculty</td>
                                <td>12</td>
                                <td>Full Semester </td>
                                <td>None</td>
                            </tr>
                            <tr>
                                <td>Students</td>
                                <td>4</td>
                                <td>One Month </td>
                                <td>Twice</td>
                            </tr>
                            <tr>
                                <td>HU Staff </td>
                                <td>4</td>
                                <td>One Month </td>
                                <td>Twice</td>
                            </tr>
                            <tr>
                                <td>Interns</td>
                                <td>1</td>
                                <td>Two weeks </td>
                                <td>None</td>
                            </tr>
                        </tbody>
                    </Table>
                    <p>Fine of Rs. 20/- per book per day is charged, in case book is not checked-in according to due date.</p>
                </div>
                </Col>
            </Row>
        </Container>
    </section>
</div>
);
}
export default BorrowingPolicies;